/**
 * Builds a new instance of the Hero component.
 * @module Hero
 * @constructor
 */

/** @lends module:Hero */
function Hero (scope, util, element, params) {
    var that = this;
    that.attribute = 'data-stry-hero';

    /*  Catch instantiation errors  */
    if (!scope && !util && !element && !params) { return; }  //  Registration condition
    else {
        if (!scope) { console.error('StoryStream -> Hero -> No scope provided.'); return; }
        if (!util) { console.error('StoryStream -> Hero -> No util available.'); return; }
        if (!element) { console.error('StoryStream -> Hero -> No element provided.'); return; }
        if (!params) { console.error('StoryStream -> Hero -> No params provided.'); return; }
    }
    /*  End  */

    that.elem = element;
    that.parallax = undefined;
    that.scroll_interval = undefined;
    that.video = undefined;


    /**
     * Funnel all events through this method and distribute.
     * @memberof Hero
     * @function handleEvent
     * @param {object} e - Event data.
     * @inner
     */
    var handleEvent = function(e, params) {
        var type = e.type ? e.type : (e.html ? 'renderer' : false);
        switch(type) {
            case 'viewport.scroll':

                //  When this hero has a video and is NOT a touch enable device
                if (that.video && !scope.viewport.is_touch) {

                    //  Clear scroll event listener if it exists
                    if (that.scroll_interval) {
                        clearInterval(that.scroll_interval);
                        that.scroll_interval = undefined;
                    }

                    //  Pause the inline video playback to improve animation performance
                    that.video.pause();

                    //  Restart the video playback if a scroll event hasn't been fired for at least
                    that.scroll_interval = setInterval(function() {

                        //  Ensure the interval parameter is reset
                        clearInterval(that.scroll_interval);
                        that.scroll_interval = undefined;

                        //  Continue video playback
                        that.video.play();

                    }, 1000);
                }

                break;
        }
    };


    /**
     * Function used construct functionality for Hero modules.
     * @memberof Hero
     * @function willConstructComponent
     * @inner
     */
    var willConstructComponent = function () {

        //  Find video element if it exists
        that.video = that.elem.getElementsByTagName('video')[0];

        //  Only do the following on non-touch device
        if (!scope.viewport.is_touch) {

            //  Auto play the inline video
            if (that.video) {
                that.video.play();
            }
        }
    };


    /**
     * Function used to initialise the application.
     * @memberof Hero
     * @function init
     * @inner
     */
    var init = function () {

        //  Setup component
        willConstructComponent();

        //  Add listeners
        scope.addEventListener('viewport.scroll', handleEvent);
    };

    init();
    return that;
}
if (typeof module !== 'undefined' && exports !== null) {
    exports.Hero = Hero;
}
